<template>
    <modal id="camp-modal" v-model="showModal" :loading="loading" :preloader="preloader" :title="generateModalTitle('camp')"
        @submit="submitData">
        <form ref="form" :data-url='selectedUrl ? selectedUrl : CAMPS' @submit.prevent="submitData">
            <div class="mb-3 required">
                <label for="campName" class="form-label">Camp Name:</label>
                <input type="text" id="campName" class="form-control" v-model="formData.camp_name" placeholder="Camp Name"
                    required />
            </div>
            <div class="mb-3 required">
                <label for="campDate" class="form-label">Date:</label>
                <input type="date" id="campDate" class="form-control" v-model="formData.date" required />
            </div>
            <div class="mb-3 required">
                <label for="campAddress" class="form-label">Address:</label>
                <textarea rows="4" id="campAddress" class="form-control" v-model="formData.address" placeholder="Address"
                    required></textarea>
            </div>
            <div class="mb-3 required">
                <label for="campCity" class="form-label">City:</label>
                <input type="text" id="campCity" class="form-control" v-model="formData.city" placeholder="City" required />
            </div>
            <div class="mb-3 required">
                <label for="branchInput"> {{ $t('select_branch') }} </label>
                <template>
                    <app-input type="search-and-select" :placeholder="$placeholder('branch')" :inputclearable="false"
                        :key="branchOrWarehouseInputKey" :options="branchOptions" v-model="formData.branch_id" />
                </template>
                <!-- <template v-if="formData.branch_id === null">
                    <app-input type="search-and-select" :placeholder="$placeholder('branch')" :inputclearable="false"
                        :key="branchOrWarehouseInputKey" :options="branchOptions" v-model="formData.branch_id" />
                </template>
                <template v-else>
                    <app-input type="search-and-select" :placeholder="$placeholder('branch')" :inputclearable="false"
                        :key="branchOrWarehouseInputKey" :options="branchOptions" v-if="formData.branch_id"
                        v-model="formData.branch_id" />
                </template> -->
            </div>
        </form>
    </modal>
</template>
<script>
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import { CAMPS, SELECTABLE_BRANCHES } from "../../../Config/ApiUrl-CPB";
import CoreLibrary from "../../../../core/helpers/CoreLibrary";
import { axiosGet, axiosPost, axiosPatch, axiosDelete, urlGenerator } from "../../../../common/Helper/AxiosHelper";
import store from "../../../../store/Index";
import { mapGetters, mapActions } from "vuex";

export default {
    name: 'CampCreateEditModal',
    extends: CoreLibrary,
    mixins: [FormHelperMixins, ModalMixin],
    data() {
        return {
            branchOrWarehouseInputKey: 1,
            branchOptions: {
                url: urlGenerator(SELECTABLE_BRANCHES),
                query_name: "search_by_name",
                per_page: 10,
                loader: "app-pre-loader", // by default 'app-overlay-loader'
                modifire: ({ id, name: value }) => ({ id, value }),
            },
            CAMPS,
            camps: [],
            formData: {
                camp_name: '',
                date: '',
                address: '',
                city: '',
            },
        };
    },
    created() {
        this.fetchCamps();
    },
    watch: {
        'formData.branch_id'() {
            if (this.getNewCashRegisterId) return;
            this.formData.id = '';
            this.cashRegisterInputKey++;
        },
        getBranchOrWarehouseId: {
            immediate: true,
            handler(newId) {
                // this.formData.branch_id = eval(newId);
                this.branchOrWarehouseInputKey++;
            }
        }
    },
    computed: {
        ...mapGetters(['getBranchOrWarehouseId', 'getNewCashRegisterId']),

        selectedBranchId() {
            return store.state.auth.branch_id;
        }
    },
    methods: {
        fetchCamps() {
            try {
                const response = axiosGet(`${CAMPS}`);
                this.camps = response.data;
            } catch (error) {
                console.error(error);
            }
        },
        submitData() {
            this.fieldStatus.isSubmit = true;
            this.loading = true;
            this.message = '';
            this.errors = {};

            // Include the selectedBranchId in the formData
            // this.formData.branch_id = this.selectedBranchId;
            // console.log(this.formData.branch_id);
            this.save(this.formData);
        },
        afterSuccess({ data }) {
            this.formData = {};
            this.preloader = false;
            $('#camp-modal').modal('hide');
            this.$emit('update-values');
            this.$emit('input', false);
            this.toastAndReload(data.message, 'camp-table');
        },
        afterSuccessFromGetEditData(response) {
            this.preloader = false;
            this.formData = response.data;
        },
    },
}
</script>

<style>
.required>label:first-child:after {
    color: #e32;
    content: ' *';
    display: inline;
}
</style>